import type { YandexSdk } from './detect'

let sdk: Promise<YandexSdk> | null = null
let readySent = false

/** Initialises the SDK once (the platform script is already on the page). */
export function yandexSdk(): Promise<YandexSdk> {
  if (!sdk) {
    const init = window.YaGames?.init
    sdk = init ? init() : Promise.reject(new Error('Yandex SDK is not on the page'))
  }
  return sdk
}

/** LoadingAPI.ready() exactly once, after the first interactive screen. */
export async function yandexReady(): Promise<void> {
  if (readySent) return
  readySent = true
  try {
    ;(await yandexSdk()).features?.LoadingAPI?.ready()
  } catch {
    readySent = false
  }
}

/** The signed player: called only after the player pressed «Играть». */
export async function yandexSignature(): Promise<string> {
  const player = await (await yandexSdk()).getPlayer({ signed: true })
  if (!player?.signature) throw new Error('no signature')
  return player.signature
}
